import ImageGalleryOtherBays from "./ImageGalleryOtherBays";
export default ImageGalleryOtherBays;
